export default __webpack_public_path__ + "static/media/fad-filter-highpass.d9c47253.svg";